import CircleIcon from '@mui/icons-material/Circle';
import { Box, Link, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { MainContainer } from '../../components/MainContainerComp';
import { Answers, Questions } from './FAQsModels';
import { bulletinIconStyle, goToTopStyle, subHeaderStyle, questionStyle } from './styled';

const AnswerComponent = ({ q, a: answer, i }: { q: string, a: string | ReactNode, i: number }) => (
  <Box id={`answer${i + 1}`} sx={{ display: 'inline-block', width: '100%' }} data-automation="qa-pair">
    <Typography sx={subHeaderStyle} className='sub-title'>{q}</Typography>
    {typeof answer === 'string' ? <Typography>{answer}</Typography> : answer}
    <Link
      href='#'
      sx={goToTopStyle}
      onClick={() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth', // Add smooth scrolling behavior
        });
      }}
      data-automation="go-to-top"
    >
      Go to top
    </Link>
  </Box>
)

export const FAQs = () => {
  const scrollToElement = (elementId: string, offset = 32) => {
    const element = document.getElementById(elementId);
    if (element) {
      const topOffset = element.offsetTop - offset;

      window.scrollTo({
        top: topOffset,
        behavior: 'smooth',
      });
    }
  };

  return (
    <MainContainer>
      <Box sx={{ wordBreak: 'break-word', mr: 1, ml: 1 }}>
        <Box>
          <Typography data-automation="faqs-description">
            To help you navigate our frequently asked questions page you can
            click on the links below to quickly get to the answer you need:
          </Typography>
          {
            Questions.map((q, i) => (
              <Typography
                onClick={() => scrollToElement(`answer${i + 1}`)}
                sx={questionStyle}
                key={q}
                data-automation="question"
              >
                <CircleIcon sx={bulletinIconStyle} />
                {q}
              </Typography>
            ))
          }
        </Box>
        <Box sx={{ mb: 4 }}>
          {
            Questions.map((q, i) => (<AnswerComponent key={q} q={q} a={Answers[i] as string | ReactNode} i={i} />))
          }
        </Box>
      </Box>
    </MainContainer>
  )
};
